import type z from 'zod'
import { boolean, object } from 'zod'

export const validationSchema = object({
  title: stringValidationSchema('title', 10, 200).regex(/[a-zA-Z]/, 'Needs to have at least 1 letter'),
  isPrivate: boolean(),
})
export type FormSchema = z.infer<typeof validationSchema>
